/**
 * 購入履歴の初期表示件数
 */
export const INITIAL_LIMIT = 30;
